import React, { FC } from "react";
import { useRouteMatch, useLocation, Link } from "react-router-dom";
import {
  Files,
  Activity,
  StickiesFill,
  CaretRightFill,
  Mailbox2,
  ShieldFill,
  Globe,
  ShieldFillPlus,
  GearWideConnected,
  Building,
  ExclamationOctagonFill,
  CreditCard2Back,
} from "react-bootstrap-icons";
interface Props {
  navItems: { path: string; title: string }[];
}

export const SecondaryNavbar: FC<Props> = ({ navItems }) => {
  const { url } = useRouteMatch();
  const { pathname } = useLocation();

  const renderIcon = (path: string) => {
    switch (path) {
      case "activity":
        return <Activity />;
      case "documents":
        return <Files />;
      case "messages":
        return <Mailbox2 />;
      case "notes":
        return <StickiesFill />;
      case "fraud":
        return <ShieldFillPlus />;
      case "business":
        return <Building />;
      case "gkyc":
        return <Globe />;
      case "ofac":
        return <ShieldFill />;
      case "decision":
        return <GearWideConnected />;
      case "watchlist":
        return <ExclamationOctagonFill />;
      case "creditreports":
        return <CreditCard2Back />;
      default:
        return <CaretRightFill />;
    }
  };

  return (
    <div className="application-navigation">
      {navItems.map((nav) => {
        return (
          <Link to={`${url}/${nav.path}`} className="d-flex">
            <div
              className={`nav-link ${
                pathname.includes(nav.path) ? "active" : ""
              }`}
              key={nav.title}
            >
              <div>{renderIcon(nav.path)}</div>
              <span className="font-weight-bold">{nav.title}</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};
